import api from './client';
import ApiError from './error';

const ProductService = {
  async searchProducts({ params }) {
    try {
      const client = await api.getClient();
      return client.searchProducts(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async publishProduct({ id }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }
        return Promise.reject(error);
      });

      return client.publishProduct(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async unPublishProduct({ id }) {
    try {
      const client = await api.getClient();
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }
        return Promise.reject(error);
      });

      return client.unPublishProduct(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getProduct({ id, include }) {
    try {
      const client = await api.getClient();
      return client.viewProduct({ id, include });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createProductAsset({
    id, name, type, description,
  }) {
    try {
      const client = await api.getClient();
      return client.createAsset({ id }, { name, type, description });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createProduct({ product }) {
    try {
      const client = await api.getClient();
      return client.createProduct(null, product);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateProduct({ id, product }) {
    try {
      const client = await api.getClient();

      client.interceptors.response.use((response) => response, (error) => {
        // Redirect after update
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateProduct(id, product);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteProduct({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteProduct(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async copyText({ textId, productIds }) {
    try {
      const client = await api.getClient();
      return client.copyText(null, { src: textId, dest: productIds });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default ProductService;
